<template>
  <v-card class="mx-3 my-3">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="itemsPaginados"
        :loading="empleadosRetirados.loading"
        hide-default-footer
        disable-pagination
      >
        <template #footer>
          <data-table-pagination
            :pagina="pagina"
            :items-por-pagina="itemsPorPagina"
            :total-items="totalItemsFiltrados"
            :loading="empleadosRetirados.loading"
            @update:pagina="actualizarPagina"
            @update:items-por-pagina="actualizarItemsPorPagina"
          />
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-col class="pl-0 pt-7" sm="4" lg="3">
              <v-text-field
                v-model="search"
                placeholder="Buscar..."
                append-icon="search"
                dense
                clearable
              />
            </v-col>
            <v-col class="justify-end d-flex">
              <slot name="botones"></slot>
            </v-col>
          </v-toolbar>
          <v-divider />
        </template>

        <template #item.Salario="{ item }">
          {{ formatterMoney(item.Salario) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatterMoney } from '../../../../utils/formatearMonedaUtil.js';
import DataTablePagination from '../../../../components/Table/DataTablePagination.vue';
import { paginacionMixin } from '../../../../mixins/paginacionMixin.js';

export default {
  name: 'EmpleadosRetiradosTable',

  components: {
    DataTablePagination,
  },

  mixins: [paginacionMixin],

  props: {
    empleadosRetirados: {
      type: Object,
      required: true,
    },
  },

  computed: {
    datosParaPaginar() {
      return this.empleadosRetirados.data;
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Identificación',
          value: 'identificacion',
          align: 'center',
          sortable: false,
        },
        { text: 'Nombres', value: 'nombreCompleto' },
        { text: 'Cargo', value: 'Cargo', sortable: false },
        { text: 'Tipo de contrato', value: 'tipoContrato', sortable: false },
        { text: 'Empresa', value: 'DescCompañia', sortable: false },
        { text: 'Sucursal', value: 'DescripcionSucursal', sortable: false },
        {
          text: 'Fecha ingreso',
          value: 'fechaIngresoFormateada',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Fecha contrato hasta',
          value: 'fechaContratoHastaFormateada',
          align: 'center',
          sortable: false,
        },
        { text: 'Salario', value: 'Salario', align: 'right' },
      ],
    };
  },

  methods: {
    formatterMoney,
  },
};
</script>
